module.exports = __webpack_public_path__ + "img/logo.e0420986.svg";